const getAppStoreConfig = () => {
  const env = process.env.NODE_ENV || "development";

  if (env === "production") {
    return {
      baseUrl:
        window.APP_STORE_CONFIG?.endpoint ||
        (window.location.href.includes("in.superagi.com")
          ? "https://app-store-service.in.superagi.com"
          : "https://app-store-service.superagi.com"),
      apiKey: window.APP_STORE_CONFIG?.key || "random_super_agi_app_store@123",
    };
  } else if (env === "staging") {
    return {
      baseUrl:
        window.APP_STORE_CONFIG?.endpoint ||
        "https://staging-app-store-service.superagi.com",
      apiKey: window.APP_STORE_CONFIG?.key || "random_super_agi_app_store@123",
    };
  } else {
    return {
      baseUrl: "http://localhost:5083",
      apiKey: "random_super_agi_app_store@123",
    };
  }
};

const { baseUrl: APP_STORE_BASE_URL, apiKey: APP_STORE_API_KEY } =
  getAppStoreConfig();

const getHeaders = (config = {}) => {
  const workspaceId = localStorage.getItem("currentWorkspaceId");
  const userId = config.userId || localStorage.getItem("userId");
  return {
    Authorization: `Bearer ${APP_STORE_API_KEY}`,
    "X-Workspace-Id": workspaceId,
    "X-User-Id": userId,
  };
};

const buildUrl = (path, config = {}) => {
  const userId = config.userId || localStorage.getItem("userId");
  const url = new URL(`${APP_STORE_BASE_URL}${path}`);
  url.searchParams.set("userId", userId);
  return url.toString();
};

export const appStoreTransport = {
  async get(url, config = {}) {
    const response = await fetch(buildUrl(url, config), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(config),
        ...config.headers,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return { data: await response.json() };
  },

  async post(url, data, config = {}) {
    const response = await fetch(buildUrl(url, config), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(config),
        ...config.headers,
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return { data: await response.json() };
  },

  async postFormData(url, formData, config = {}) {
    const response = await fetch(buildUrl(url, config), {
      method: "POST",
      headers: {
        ...getHeaders(config),
        ...config.headers,
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return { data: await response.json() };
  },

  async put(url, data, config = {}) {
    const response = await fetch(buildUrl(url, config), {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(config),
        ...config.headers,
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return { data: await response.json() };
  },

  async delete(url, config = {}) {
    const response = await fetch(buildUrl(url, config), {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(config),
        ...config.headers,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return { data: await response.json() };
  },
};

export { APP_STORE_BASE_URL, APP_STORE_API_KEY };
